import React from 'react'

import { ChatbotInputField } from '/react4xp/shared/chatbot-input-field/chatbot-input-field'

export default (props) => <ChatbotInputField {...props} />
